import { createAction, props } from '@ngrx/store';
import { Accommodation } from '@uc/web/shared/data-models';

export const fetchAccommodationsList = createAction(
	'[StateAccommodations/API] Fetch Accommodations List',
	props<{ universityUrl: string }>(),
);

export const updateAccommodationsList = createAction(
	'[StateAccommodations/API] Update Accommodations List',
	props<{ accommodation: Accommodation | null }>(),
);

export const updateAccommodationsUniversityUrl = createAction(
	'[StateAccommodations/API] Update Accommodations University Url',
	props<{ universityUrl: string }>(),
);

export const loadStateAccommodationsFailure = createAction(
	'[StateAccommodations/API] Load StateAccommodations Failure',
	props<{ error: any }>(),
);
